var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63568 8.47099L2.81246 8.64777L2.63568 8.47099C2.34279 8.76389 2.34279 9.23871 2.63568 9.53161L2.63568 9.53161L5.63568 12.5316C5.92857 12.8245 6.40346 12.8245 6.69635 12.5316L14.0297 5.1983C14.3226 4.90541 14.3226 4.43053 14.0297 4.13763C13.7368 3.84475 13.2619 3.84475 12.969 4.13763L12.969 4.13764L6.16601 10.9406L3.69635 8.47099C3.69635 8.47099 3.69634 8.47099 3.69634 8.47099C3.40345 8.17809 2.92857 8.17809 2.63568 8.47099Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.a8ac2c7c44d8f90d81da5c53024bc81a.svg";
export { ForwardRef as ReactComponent };